<template>
  <WsCreate
    ref="wsCreate"
    :modelName="modelName"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    :customBtns="customBtns"
    @cancel="$_onCancel"
    @submit="$_onCreate"
    @input="$_onInputCreateData"
  >
    <WsAlertDialog
      ref="alertPopup"
      btnText="確定"
      color="primary"
      :title="alertPopup.title"
      @submit="$_onClickAlertPopup"
    />
  </WsCreate>
</template>

<script>
import model from '@/models/act';
import S_idtf from '@/services/api/v1/idtf';
import S_act from '@/services/api/v1/act';
import S_actVersion from '@/services/api/v1/actVersion';
import H_act from '@/helpers/act';
import H_idtf from '@/helpers/idtf';

export default {
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.app.needSave) {
      const ans = window.confirm('確認捨棄目前編輯內容嗎？');
      if (ans) {
        this.$store.dispatch('app/stopNeedSave');
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  data() {
    return {
      modelName: model.modelName,
      label: model.label,
      fields: model.fields,
      pageSetting: {
        primary: [
          {
            type: 'infoCard',
            floors: [
              {
                title: '法規內容',
                fields: ['last_version'],
                hideLabelFields: ['last_version'],
              },
            ],
          },
        ],
        secondary: [
          {
            type: 'infoCard',
            floors: [
              {
                title: '設定',
                fields: [
                  'sequence',
                  'areas',
                  'industry_categories',
                  'system_classes',
                  'system_subclasses',
                  'act_type',
                  'range_type',
                  'factories',
                  'exclusive_factories',
                ],
              },
            ],
          },
          {
            type: 'infoCard',
            floors: [
              {
                title: '狀態',
                fields: ['act_status'],
                hideLabelFields: ['act_status'],
              },
            ],
          },
          {
            type: 'infoCard',
            floors: [
              {
                title: '顯示設定',
                remark: '隱藏的內容將不會顯示於使用者前台介面',
                fields: ['is_active'],
              },
            ],
          },
          {
            type: 'infoCard',
            floors: [
              {
                title: '標籤設定',
                remark: '標籤僅供後台檢索，不影響前台使用',
                fields: ['tags'],
                hideLabelFields: ['tags'],
              },
            ],
          },
          {
            type: 'infoCard',
            floors: [
              {
                title: '鑑別設定',
                fields: [
                  'is_released_after_content_review',
                  'is_need_lawyer_idtf',
                  'km_owners',
                  'km_backups',
                  'km_reviewers',
                  'idtf_owners',
                  'idtf_backups',
                  'idtf_reviewers',
                  'overall_owners',
                ],
              },
            ],
          },
        ],
      },
      customBtns: {
        isHideRegularBtns: true,
        btns: [
          {
            color: 'textSecondary',
            outlined: true,
            title: '取消',
            emit: 'cancel',
          },
          {
            color: 'primary',
            title: '送出',
            isValidateForm: true,
            emit: 'submit',
          },
        ],
      },
      alertPopup: {
        type: '',
        title: '',
      },
      actId: null,
      idtfId: null,
    };
  },
  methods: {
    $_onCancel() {
      this.$router.go(-1);
    },
    async $_onCreate($event) {
      const { createData } = $event;
      try {
        const data = H_act.setCreateData(createData);
        const { id: actId } = await S_act.create(data);
        this.actId = actId;
        const { id: actVersionId} = await S_actVersion.createUnReleased(actId, data.last_version);
        const { id: idtfId } = await this.$_createIdtf(actVersionId, data);
        this.idtfId = idtfId;
        await S_idtf.createIdtfItem({act_version: actVersionId}, idtfId);
        this.$store.dispatch('app/stopNeedSave');
        this.$_setAlert('success');
      } catch (error) {
        this.$_setAlert('error', error);
      }
    },
    $_onInputCreateData(createData) {
      const { is_released_after_content_review } = createData;
      if (!is_released_after_content_review) createData.is_need_lawyer_idtf = true;
    },
    async $_createIdtf(actVersionId, data) {
      const createIdtfData = H_idtf.setCreateIdtfData(actVersionId, data);
      return await S_idtf.create(createIdtfData);
    },
    $_setAlert(type, error) {
      const titleList = {
        'success': '法規已建立，目前處於未發布狀態，前往法規內容格式更新作業內頁新增法條後，繼續鑑別流程',
        'error': `法規建立失敗，請重新建立。 Error: ${error}`,
      };
      this.alertPopup = {
        ...this.alertPopup,
        type,
        title: titleList[type],
      };
      this.$refs.alertPopup.open();
    },
    $_onClickAlertPopup() {
      this.$refs.alertPopup.close();
      if (this.alertPopup.type === 'success') this.$router.push(`/act_cnt_update/${this.idtfId}?act=${this.actId}`);
    },
  },
};
</script>